document.addEventListener("DOMContentLoaded", function () {
  var desc = document.querySelector(".collection-hero__description");
  var btn = document.getElementById("hc-read-more-toggle");

  if (!desc || !btn) return;

  var originalHeight = desc.scrollHeight;
  if (desc.offsetHeight >= originalHeight) {
    btn.style.display = 'none';
  }

  btn.addEventListener("click", function () {
    desc.classList.toggle("expanded");
    btn.textContent = desc.classList.contains("expanded") ? "Read less" : "Read more";
  });
});

document.addEventListener("click", function (e) {
  const a = e.target.closest('.hc-popup-link a[data-src^="#"], .hc-popup-link a[href^="#"]');
  if (!a) return;

  const src = a.getAttribute("data-src") || a.getAttribute("href");
  if (!src || src === "#") return;

  const node = document.querySelector(src);
  if (!node) return;

  e.preventDefault();
  e.stopPropagation();

  Fancybox.show([{ src, type: "inline" }], {
    hideScrollbar: false,
    closeButton: "inside"
  });
}, true);